"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ palette }) => ({
    categoryName: {
        fontWeight: 500,
    },
    rootNode: {
        textTransform: 'uppercase',
        '&.rollup': {
            background: palette.action.selected,
            width: 'inherit',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 5,
        },
    },
});
exports.styles = styles;
